/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./pushToTalk.vue?vue&type=template&id=23b4abe0&scoped=true&"
import script from "./pushToTalk.vue?vue&type=script&lang=js&"
export * from "./pushToTalk.vue?vue&type=script&lang=js&"
import style0 from "./pushToTalk.vue?vue&type=style&index=0&id=23b4abe0&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23b4abe0",
  null
  
)

export default component.exports